export default {
  timeFormat: 'h:mm:ssaaa',
};
